import { useEffect } from 'react';
function useAnyAction(callback) {
  useEffect(function () {
    if (callback) {
      // trigger callback on key, click, or mouse move
      window.addEventListener('keydown', callback);
      window.addEventListener('click', callback);
      window.addEventListener('mousemove', callback);
    }
    return function () {
      if (callback) {
        window.removeEventListener('keydown', callback);
        window.removeEventListener('click', callback);
        window.removeEventListener('mousemove', callback);
      }
    };
  }, [callback]);
}
export default useAnyAction;